import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Divider } from "@material-ui/core";
import { getSubAdminUserService } from "../../../../utils/services/userManagement/subAdmin/subAdminServices";
import { SendInvitationService } from "../../../../utils/services/webinar/webinarService";
import { toast } from "react-toastify";

const EnrolSubAdminDialog = ({
  isOpen,
  setIsOpen,
  enrollSubAdminLists,
  loadMoreItems,
  subAdminMeetingId,
}) => {
  const [personName, setPersonName] = useState([]);

  console.log(enrollSubAdminLists, "subadmin kissasdasdxzxc");

  //   const handleChange = (event) => {
  //     console.log("change name --> ", event.target.value);
  //     const {
  //       target: { value },
  //     } = event;

  //     console.log("thi sis the value -> ", value);

  //     setPersonName(
  //       // On autofill we get a stringified value.
  //       typeof value === "string" ? value.split(",") : value
  //     );
  //   };

  const handleChange = (event) => {
    setPersonName(event.target.value);
  };

  const panelHeight = 200;
  function fetchMoreData(event) {
    if (event.target.scrollTop + panelHeight === event.target.scrollHeight) {
      loadMoreItems();
    }
  }

  const handleDialogClose = () => {
    setIsOpen(false);
  };

  const SendInvitation = async (payload) => {
    try {
      const result = await SendInvitationService(payload);

      console.log("result -> ", result);
      if (result?.statusCode === 200) {
        setIsOpen(false);
        toast.success("Invitation Send Successfully !!! ", {
          toastId: "Send-Invite-1",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSendInvitation = async () => {
    let subadminDetail = personName.map((item) => ({
      name: item.auth.name,
      email: item.auth.email,
    }));

    const payload = {
      invitation: subadminDetail,
      meetingId: subAdminMeetingId,
    };

    console.log("Send the payload  ", payload);
    SendInvitation(payload);
    setPersonName([]);
  };

  const handleCancel = () => {
    setPersonName([]);
  };

  return (
    <div>
      <Dialog
        maxWidth="md"
        className="enroll_subAdmin"
        open={isOpen}
        onClose={handleDialogClose}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #E6E6E6",
            display: "flex",
            justifyContent: "space-between",
            paddingTop: "1.6rem",
            divider: false, // Remove the default divider
          }}
        >
          <h1 style={{ fontSize: "1.5rem", fontWeight: "700" }}>
            Enroll Sub Admin
          </h1>
          <CloseIcon onClick={handleDialogClose} sx={{ cursor: "pointer" }} />
        </DialogTitle>
        <DialogContent style={{ width: "800px", overflow: "hidden" }} dividers>
          <Box>
            <Box>
              <Typography>Select Sub Admins</Typography>
            </Box>
            <Box>
              <FormControl sx={{ m: 1, width: "97%" }}>
                <InputLabel id="demo-multiple-checkbox-label">Tag</InputLabel>
                {console.log("hello personName -> ", personName)}
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  value={personName}
                  onChange={handleChange}
                  input={<OutlinedInput label="Tag" />}
                  //   renderValue={(selected) => selected.join(", ")}
                  renderValue={(selected) =>
                    selected.map((item) => item.auth.name).join(", ")
                  }
                  MenuProps={{
                    PaperProps: {
                      onScroll: fetchMoreData,
                      style: {
                        maxHeight: panelHeight,
                        overflowY: "scroll",
                        // overflowY:'scroll'
                        // maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                        width: 250,
                      },
                    },
                  }}
                >
                  {/* {enrollSubAdminLists &&
                    enrollSubAdminLists?.map((item, index) => (
                      <>
                        {console.log("hell0", item)}
                        <MenuItem key={index} value={item.auth.name}>
                          <Checkbox checked={personName.indexOf(item) > -1} />
                          <ListItemText primary={item.auth.name} />
                        </MenuItem>
                      </>
                    ))} */}
                  {enrollSubAdminLists &&
                    enrollSubAdminLists?.map((item, index) => (
                      <MenuItem key={item?.id} value={item}>
                        <Checkbox
                          size="small"
                          checked={personName.some(
                            (selectedItem) =>
                              selectedItem.auth.name === item.auth.name
                          )}
                        />
                        <ListItemText primary={item.auth.name} />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
        </DialogContent>
        <Divider />
        <Box
          className="flex justify-between"
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: "1rem 1.5rem",
          }}
        >
          <Box>
            <Typography>
              <span> {personName.length} </span> Selected
            </Typography>
          </Box>
          <Box>
            <Button
              sx={{
                fontWeight: "600",
                lineHeight: "100%",
                color: "#333",
              }}
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              disabled={personName.length === 0}
              variant="contained"
              sx={{
                backgroundColor: "#8DADFD",
                borderRadius: "0.5rem",
                lineHeight: "100%",
                color: "white",
                padding: "0.65rem",
              }}
              onClick={handleSendInvitation}
            >
              Send Invitation
            </Button>
          </Box>
        </Box>
      </Dialog>
    </div>
  );
};

export default EnrolSubAdminDialog;
